import deleteM from "./delete.js";
import findM from "./find.js";
import getM from "./get.js";
import initM from "./init.js";
import saveM from "./save.js";
import searchM from "./search.js";
import updatesM from "./updates.js";

export default (app) => {
  deleteM(app);
  findM(app);
  getM(app);
  initM(app);
  saveM(app);
  searchM(app);
  updatesM(app);

  app.database.on("init", 900, async (query) => {
    await app.database.event("initMemory", { ...query, inited: false });
    await app.database.event("initStorage", { ...query, inited: false });
  });

  app.database.on("initMemory", ({ collection, db, inited }) => {
    if (inited) return;
    collection.on("size", () => db.dbArray.length);
    collection.on("init", () => {
      const { dbArray, dbIndex } = db;
      dbArray.forEach((item) => {
        if (dbIndex[item._id]) dbArray.splice(dbArray.indexOf(dbIndex[item._id]), 1);
        dbIndex[item._id] = item;
      });
    });
  });

  app.database.on(
    "init",
    ({ contentType }) => {
      const db = app.addeventhandler({ dbArray: [], dbIndex: {} }, ["get", "updates"]);

      const collection = app.addeventhandler(
        { contentType },
        ["delete", "find", "get", "init", "save", "search", "size", "update", "updates"],
        `database ${contentType.machinename}`,
      );

      return { collection, db, contentType };
    },
    1000,
  );
};
